import React from 'react';
import { useZitoneoUI } from '../../../contexts/ZitoneoUIContext';
import { VisibleContentScope } from '../../../types/zitoneoServicesTypes';
import ContentModeSelector from './ContentModeSelector';
import RoomSelector from './RoomSelector';
import SearchServices from './SearchServices';

const HeaderEditorControls = () => {
    const { visibleContentScope } = useZitoneoUI();

    return (
        <div className='zitoneo-header__editor-controls'>
            <ContentModeSelector />
            {visibleContentScope === VisibleContentScope.ROOM && (
                <RoomSelector />
            )}
            <SearchServices />
        </div>
    );
};

export default HeaderEditorControls;
